import { IMAGE_FILE_TYPES } from './../../consts/common-constants';
import { Component, OnInit, Input, Output, EventEmitter, SimpleChange } from '@angular/core';
import { AttachmentCategory } from 'shared/enums';
import { uploadUrl, handleUploadChange } from 'shared/utils';
import { NzUploadFile, NzUploadChangeParam } from 'ng-zorro-antd/upload';

@Component({
  selector: 'image-uploader',
  templateUrl: './image-uploader.component.html',
  styleUrls: ['./image-uploader.component.scss']
})
export class ImageUploaderComponent implements OnInit {

  files: NzUploadFile[] = [];
  uploadUrl:string;
  imageFileType=IMAGE_FILE_TYPES;
  @Input("limit") limit: number;
  @Input("initFiles") initFiles: NzUploadFile[];
  @Input("category") category:AttachmentCategory;
  @Output() fileNameChanged: EventEmitter<any> = new EventEmitter<any>();
  @Output() fileDeleted: EventEmitter<any> = new EventEmitter<any>();
  constructor(
  ) {}

  ngOnInit(): void {
    if(!this.limit){
      this.limit=1;
    }
    if(this.category){
      this.uploadUrl=uploadUrl(this.category);
    }
  }

  ngOnChanges(changes: SimpleChange) {
    if(this.initFiles){
      this.files=this.initFiles;
    }
  }

  onRemove=(file: NzUploadFile)=>{
    this.fileDeleted.emit(file);
    return true;
  }
  
  fileListChange(files: NzUploadFile[]) {
    this.files = files;
   
    // if (files.length > 0) {
    //   this.form.controls['image'].setValue(files[0].name);
    // }

  }

  uploadChange(e: NzUploadChangeParam) {
    handleUploadChange(e);
    if(e.file.status == "done"){
    this.fileNameChanged.emit(this.files);
    }
  }



}
